import { Injectable, inject } from '@angular/core';
import { EnvService } from '@lib/env';
import { HttpClient } from '@angular/common/http';
import { UriBuilder } from 'uribuilder';
import { Observable } from 'rxjs';
import { CustomerDepartmentDto } from '../types/CustomerDepartment';

@Injectable({ providedIn: 'root' })
export class DepartmentSearchService {
    private readonly env = inject(EnvService);
    private readonly http = inject(HttpClient);


    public getDepartment(searchQuery: string): Observable<CustomerDepartmentDto[]> {
        const url: UriBuilder = this.getBase('department');

        url.query['searchQuery'] = searchQuery;

        return this.http.get<CustomerDepartmentDto[]>(url.toString());
    }

    private getBase(...pathSegments: string[]): UriBuilder {
        return this.env.getBase('customer', 'company', ...pathSegments);
    }
}
